import { createAction } from 'redux-actions';
export const FETCH_SECTION = 'FETCH_SECTION';
export const FETCH_SECTION_SUCCESS = 'FETCH_SECTION_SUCCESS';

export const fetchSection = createAction(FETCH_SECTION, (section: string) => ({
  section,
}));

export const fetchSectionSuccess = createAction(
  FETCH_SECTION_SUCCESS,
  (section: string) => ({
    section,
  })
);

export const setSectionStreamId = createAction(
  'SECTION.SET_STREAMID',
  (streamId: string) => ({
    streamId,
  })
);
